var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 14.414v7.435a.152.152 0 0 0 .152.151h9.7a.152.152 0 0 0 .148-.151v-7.435l-5-5z",
    fill: "#d3d5da",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 1a15 15 0 1 0 15 15 15.017 15.017 0 0 0 -15-15zm8.207 15.207a.95.95 0 0 1 -1.207.138v5.5a2.154 2.154 0 0 1 -2.152 2.155h-9.7a2.154 2.154 0 0 1 -2.148-2.151v-5.5a.986.986 0 0 1 -1.207-.138 1 1 0 0 1 0-1.414l1.5-1.5 6-6a1 1 0 0 1 1.414 0l6 6 1.5 1.5a1 1 0 0 1 0 1.41z",
    fill: "#d3d5da",
    "data-original": "#000000",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGrey);
export default __webpack_public_path__ + "static/media/HomeGrey.1a9dd3dec7f1a4960b66ab9a14079db8.svg";
export { ForwardRef as ReactComponent };